/* eslint-disable @typescript-eslint/no-empty-function */
import { onErrorHandler, onSuccessHandler } from 'app/utils/helpers';
import React, { useMemo, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ModalProvider } from './Modal';
import { SettingsProvider } from './settings/appSettings';

const ReactQueryProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => {
  const [openModalProp, setOpenModalProp] = useState<any>(null);
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
            refetchOnWindowFocus: false,
            retry: false,
            onError: (err) => onErrorHandler(err, setOpenModalProp), //, true),
            onSuccess: onSuccessHandler as any,
          },
          mutations: {
            onError: (err) => onErrorHandler(err, setOpenModalProp),
            onSuccess: onSuccessHandler as any,
          },
        },
      }),
    []
  );

  return (
    <QueryClientProvider client={queryClient}>
      <SettingsProvider>
        <ModalProvider openModalProp={openModalProp}>{children}</ModalProvider>
      </SettingsProvider>
    </QueryClientProvider>
  );
};
export default ReactQueryProvider;
